import { SVGProps } from "react";

export default function ThumbsDownReactionIcon(
  props: SVGProps<SVGSVGElement> & { accent?: string },
) {
  const {
    height = 20,
    width = 20,
    stroke = "#757575",
    accent = "#AFAFAF",
    ...rest
  } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M13.7668 4.70801L11.1834 2.70801C10.8501 2.37467 10.1001 2.20801 9.6001 2.20801H6.43344C5.43344 2.20801 4.3501 2.95801 4.1001 3.95801L2.1001 10.0413C1.68344 11.208 2.43344 12.208 3.68344 12.208H7.01677C7.51677 12.208 7.93344 12.6247 7.8501 13.208L7.43344 15.8747C7.26677 16.6247 7.76677 17.458 8.51677 17.708C9.18344 17.958 10.0168 17.6247 10.3501 17.1247L13.7668 12.0413"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M18.0182 4.70833V12.875C18.0182 14.0417 17.5182 14.4583 16.3516 14.4583H15.5182C14.3516 14.4583 13.8516 14.0417 13.8516 12.875V4.70833C13.8516 3.54167 14.3516 3.125 15.5182 3.125H16.3516C17.5182 3.125 18.0182 3.54167 18.0182 4.70833Z"
        stroke={accent}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
